// Generated from Enterprise.Domain.Permissions (API/src/Enterprise.Domain/Entities/User.cs). Do not edit by hand:
// a test checks that the two agree. The API stores, sends and is sent these numbers: a permission is never written as a
// name (the names are the API permissions', like shipping:truck:read).

/**
 * What a user can be given, in a service center. A page or an element asks for the permission that is for it.
 */
export enum Permissions {
    /** Dashboard */
    Dashboard = 1,
    /** Reports > Transportation > Shipment Export */
    ReportsTransportationShipmentExport = 2,
    /** Reports > Transportation > Shipment Metric */
    ReportsTransportationShipmentMetric = 3,
    /** Reports > Production > Terre Haute Paperwork */
    ReportsProductionTerreHautePaperwork = 4,
    /** Reports > Production > Production Paperwork (Development) */
    ReportsProductionProductionPaperworkDevelopment = 5,
    /** Reports > Production > Production Paperwork (Orders) */
    ReportsProductionProductionPaperworkOrders = 6,
    /** Reports > Production > Production Paperwork (Single) */
    ReportsProductionProductionPaperworkSingle = 7,
    /** Reports > Production > Roll Forming Paperwork */
    ReportsProductionRollFormingPaperwork = 8,
    /** Reports > Production > Short Door */
    ReportsProductionShortDoor = 9,
    /** Reports > Production > Custom Accent */
    ReportsProductionCustomAccent = 10,
    /** Reports > Production > Stickers */
    ReportsProductionStickers = 11,
    /** Reports > Production > Windload Checklist */
    ReportsProductionWindloadChecklist = 12,
    /** Reports > Production > Order Errors */
    ReportsProductionOrderErrors = 13,
    /** Reports > Production > Fullview Export */
    ReportsProductionFullviewExport = 14,
    /** Reports > Production > Engineering Review by Cutoff Date */
    ReportsProductionEngineeringReviewByCutoffDate = 15,
    /** Reports > Accounting > Credits */
    ReportsAccountingCredits = 16,
    /** Reports > Accounting > Accountmate Financials */
    ReportsAccountingAccountmateFinancials = 17,
    /** Reports > Accounting > Open Orders */
    ReportsAccountingOpenOrders = 18,
    /** Reports > Accounting > Released Orders */
    ReportsAccountingReleasedOrders = 19,
    /** Reports > Accounting > Dealer Statement */
    ReportsAccountingDealerStatement = 20,
    /** Reports > Accounting > Payroll Comparison */
    ReportsAccountingPayrollComparison = 21,
    /** Reports > Accounting > Monthly Invoice Report */
    ReportsAccountingMonthlyInvoiceReport = 22,
    /** Reports > Accounting > Tax Breakdown Report */
    ReportsAccountingTaxBreakdownReport = 23,
    /** Ordering > Orders */
    OrderingOrders = 24,
    /** Ordering > Backorder */
    OrderingBackorder = 25,
    /** Ordering > Sync */
    OrderingSync = 26,
    /** Approvals > Credit Hold */
    ApprovalsCreditHold = 27,
    /** Approvals > Engineering */
    ApprovalsEngineering = 28,
    /** Approvals > Wind Load */
    ApprovalsWindLoad = 29,
    /** Approvals > Customer Service */
    ApprovalsCustomerService = 30,
    /** Approvals > Addresses > Save */
    ApprovalsAddressesSave = 31,
    /** Approvals > Addresses > Approve */
    ApprovalsAddressesApprove = 32,
    /** Routing > Routing */
    RoutingRouting = 33,
    /** Shipping > Trucks > View */
    ShippingTrucksView = 34,
    /** Shipping > Trucks > Edit */
    ShippingTrucksEdit = 35,
    /** Shipping > Trucks > Delete */
    ShippingTrucksDelete = 36,
    /** Shipping > Containers > View */
    ShippingContainersView = 37,
    /** Shipping > Containers > Edit */
    ShippingContainersEdit = 38,
    /** Shipping > Containers > Delete */
    ShippingContainersDelete = 39,
    /** Shipping > Pickups > View */
    ShippingPickupsView = 40,
    /** Shipping > Pickups > Edit */
    ShippingPickupsEdit = 41,
    /** Shipping > Pickups > Delete */
    ShippingPickupsDelete = 42,
    /** Shipping > Fedex > View */
    ShippingFedexView = 43,
    /** Shipping > Fedex > Ship */
    ShippingFedexShip = 44,
    /** Shipping > Fleet > Drivers > View */
    ShippingFleetDriversView = 45,
    /** Shipping > Fleet > Drivers > Create */
    ShippingFleetDriversCreate = 46,
    /** Shipping > Fleet > Drivers > Edit */
    ShippingFleetDriversEdit = 47,
    /** Shipping > Fleet > Assets > View */
    ShippingFleetAssetsView = 48,
    /** Shipping > Fleet > Assets > Create */
    ShippingFleetAssetsCreate = 49,
    /** Shipping > Fleet > Assets > Edit */
    ShippingFleetAssetsEdit = 50,
    /** Invoicing > Invoices */
    InvoicingInvoices = 51,
    /** Invoicing > Credits */
    InvoicingCredits = 52,
    /** Invoicing > Billing Only > View */
    InvoicingBillingOnlyView = 53,
    /** Invoicing > Billing Only > Invoice */
    InvoicingBillingOnlyInvoice = 54,
    /** Communications > Shipments > Trucks > View */
    CommunicationsShipmentsTrucksView = 55,
    /** Communications > Shipments > Trucks > Send */
    CommunicationsShipmentsTrucksSend = 56,
    /** Communications > Shipments > Containers > View */
    CommunicationsShipmentsContainersView = 57,
    /** Communications > Shipments > Containers > Send */
    CommunicationsShipmentsContainersSend = 58,
    /** Communications > Mail Triage > Process Pending */
    CommunicationsMailTriageProcessPending = 59,
    /** Communications > Mail Triage > Mark Done */
    CommunicationsMailTriageMarkDone = 60,
    /** Communications > Mail Triage > View */
    CommunicationsMailTriageView = 61,
    /** Communications > Activity Feed > View */
    CommunicationsActivityFeedView = 62,
    /** Communications > Activity Feed > Resend */
    CommunicationsActivityFeedResend = 63,
    /** Inventory > Physical > Create */
    InventoryPhysicalCreate = 64,
    /** Inventory > Physical > Refresh Pricing */
    InventoryPhysicalRefreshPricing = 65,
    /** Inventory > Physical > Control Groups > View */
    InventoryPhysicalControlGroupsView = 66,
    /** Inventory > Physical > Control Groups > Edit */
    InventoryPhysicalControlGroupsEdit = 67,
    /** Inventory > Physical > Shipments > View */
    InventoryPhysicalShipmentsView = 68,
    /** Inventory > Physical > Shipments > Edit */
    InventoryPhysicalShipmentsEdit = 69,
    /** Inventory > Physical > Orders > View */
    InventoryPhysicalOrdersView = 70,
    /** Inventory > Physical > Orders > Edit */
    InventoryPhysicalOrdersEdit = 71,
    /** Inventory > Physical > Adjustments > View */
    InventoryPhysicalAdjustmentsView = 72,
    /** Inventory > Physical > Adjustments > Edit */
    InventoryPhysicalAdjustmentsEdit = 73,
    /** Inventory > Physical > Reports > View */
    InventoryPhysicalReportsView = 74,
    /** Inventory > Physical > Reports > Edit */
    InventoryPhysicalReportsEdit = 75,
    /** Support > Activity Feed */
    SupportActivityFeed = 76,
    /** Support > Users > Create */
    SupportUsersCreate = 77,
    /** Support > Users > View */
    SupportUsersView = 78,
    /** Support > Users > Save */
    SupportUsersSave = 79,
    /** Support > Users > Delete */
    SupportUsersDelete = 80,
    /** Production > Planning > Orders > View */
    ProductionMetricsPickupsView = 85,
    /** Production > Planning > Shipments > View */
    ProductionMetricsDeliveriesView = 86,
    /** Production > Planning > Create Run */
    ProductionMetricsCreateRun = 87,
    /** Production > Schedule (CD/OEM) > View */
    ProductionScheduleView = 89,
    /** Production > Schedule > Sort */
    ProductionScheduleSort = 90,
    /** Production > Schedule > Jobs */
    ProductionScheduleJobs = 91,
    /** Production > Schedule > Runs */
    ProductionScheduleRuns = 92,
    /** Support > Dealers > View */
    SupportDealersView = 93,
    /** Support > Dealers > Edit */
    SupportDealersEdit = 94,
    /** Support > Dealers > Address Override */
    SupportDealersAddressOverride = 95,
    /** Support > Dealers > Reverse Credit */
    SupportDealersReverseCredit = 96,
    /** Inventory > Physical > View */
    InventoryPhysicalView = 97,
    /** Approvals > Addresses > View */
    ApprovalsAddressesView = 98,
    /** Approvals > Credit Hold > View */
    ApprovalsCreditHoldView = 99,
    /** Approvals > Credit Hold > Approve */
    ApprovalsCreditHoldApprove = 100,
    /** Routing > Routing > View */
    RoutingRoutingView = 101,
    /** Routing > Routing > Import */
    RoutingRoutingImport = 102,
    /** Production > Schedule (RS) > View */
    ProductionScheduleRsView = 103,
    /** Support > Dealers > Sales */
    SupportDealersSales = 104,
}

/** What the API calls each permission, and how the administration screen shows it. */
export interface PermissionDetail {
    /** Where it is in the menu, like "Shipping > Trucks > View" */
    display: string;
}

export const PermissionDetails: { [permission in Permissions]: PermissionDetail } = {
    [Permissions.Dashboard]: { display: 'Dashboard' },
    [Permissions.ReportsTransportationShipmentExport]: { display: 'Reports > Transportation > Shipment Export' },
    [Permissions.ReportsTransportationShipmentMetric]: { display: 'Reports > Transportation > Shipment Metric' },
    [Permissions.ReportsProductionTerreHautePaperwork]: { display: 'Reports > Production > Terre Haute Paperwork' },
    [Permissions.ReportsProductionProductionPaperworkDevelopment]: { display: 'Reports > Production > Production Paperwork (Development)' },
    [Permissions.ReportsProductionProductionPaperworkOrders]: { display: 'Reports > Production > Production Paperwork (Orders)' },
    [Permissions.ReportsProductionProductionPaperworkSingle]: { display: 'Reports > Production > Production Paperwork (Single)' },
    [Permissions.ReportsProductionRollFormingPaperwork]: { display: 'Reports > Production > Roll Forming Paperwork' },
    [Permissions.ReportsProductionShortDoor]: { display: 'Reports > Production > Short Door' },
    [Permissions.ReportsProductionCustomAccent]: { display: 'Reports > Production > Custom Accent' },
    [Permissions.ReportsProductionStickers]: { display: 'Reports > Production > Stickers' },
    [Permissions.ReportsProductionWindloadChecklist]: { display: 'Reports > Production > Windload Checklist' },
    [Permissions.ReportsProductionOrderErrors]: { display: 'Reports > Production > Order Errors' },
    [Permissions.ReportsProductionFullviewExport]: { display: 'Reports > Production > Fullview Export' },
    [Permissions.ReportsProductionEngineeringReviewByCutoffDate]: { display: 'Reports > Production > Engineering Review by Cutoff Date' },
    [Permissions.ReportsAccountingCredits]: { display: 'Reports > Accounting > Credits' },
    [Permissions.ReportsAccountingAccountmateFinancials]: { display: 'Reports > Accounting > Accountmate Financials' },
    [Permissions.ReportsAccountingOpenOrders]: { display: 'Reports > Accounting > Open Orders' },
    [Permissions.ReportsAccountingReleasedOrders]: { display: 'Reports > Accounting > Released Orders' },
    [Permissions.ReportsAccountingDealerStatement]: { display: 'Reports > Accounting > Dealer Statement' },
    [Permissions.ReportsAccountingPayrollComparison]: { display: 'Reports > Accounting > Payroll Comparison' },
    [Permissions.ReportsAccountingMonthlyInvoiceReport]: { display: 'Reports > Accounting > Monthly Invoice Report' },
    [Permissions.ReportsAccountingTaxBreakdownReport]: { display: 'Reports > Accounting > Tax Breakdown Report' },
    [Permissions.OrderingOrders]: { display: 'Ordering > Orders' },
    [Permissions.OrderingBackorder]: { display: 'Ordering > Backorder' },
    [Permissions.OrderingSync]: { display: 'Ordering > Sync' },
    [Permissions.ApprovalsCreditHold]: { display: 'Approvals > Credit Hold' },
    [Permissions.ApprovalsEngineering]: { display: 'Approvals > Engineering' },
    [Permissions.ApprovalsWindLoad]: { display: 'Approvals > Wind Load' },
    [Permissions.ApprovalsCustomerService]: { display: 'Approvals > Customer Service' },
    [Permissions.ApprovalsAddressesSave]: { display: 'Approvals > Addresses > Save' },
    [Permissions.ApprovalsAddressesApprove]: { display: 'Approvals > Addresses > Approve' },
    [Permissions.RoutingRouting]: { display: 'Routing > Routing' },
    [Permissions.ShippingTrucksView]: { display: 'Shipping > Trucks > View' },
    [Permissions.ShippingTrucksEdit]: { display: 'Shipping > Trucks > Edit' },
    [Permissions.ShippingTrucksDelete]: { display: 'Shipping > Trucks > Delete' },
    [Permissions.ShippingContainersView]: { display: 'Shipping > Containers > View' },
    [Permissions.ShippingContainersEdit]: { display: 'Shipping > Containers > Edit' },
    [Permissions.ShippingContainersDelete]: { display: 'Shipping > Containers > Delete' },
    [Permissions.ShippingPickupsView]: { display: 'Shipping > Pickups > View' },
    [Permissions.ShippingPickupsEdit]: { display: 'Shipping > Pickups > Edit' },
    [Permissions.ShippingPickupsDelete]: { display: 'Shipping > Pickups > Delete' },
    [Permissions.ShippingFedexView]: { display: 'Shipping > Fedex > View' },
    [Permissions.ShippingFedexShip]: { display: 'Shipping > Fedex > Ship' },
    [Permissions.ShippingFleetDriversView]: { display: 'Shipping > Fleet > Drivers > View' },
    [Permissions.ShippingFleetDriversCreate]: { display: 'Shipping > Fleet > Drivers > Create' },
    [Permissions.ShippingFleetDriversEdit]: { display: 'Shipping > Fleet > Drivers > Edit' },
    [Permissions.ShippingFleetAssetsView]: { display: 'Shipping > Fleet > Assets > View' },
    [Permissions.ShippingFleetAssetsCreate]: { display: 'Shipping > Fleet > Assets > Create' },
    [Permissions.ShippingFleetAssetsEdit]: { display: 'Shipping > Fleet > Assets > Edit' },
    [Permissions.InvoicingInvoices]: { display: 'Invoicing > Invoices' },
    [Permissions.InvoicingCredits]: { display: 'Invoicing > Credits' },
    [Permissions.InvoicingBillingOnlyView]: { display: 'Invoicing > Billing Only > View' },
    [Permissions.InvoicingBillingOnlyInvoice]: { display: 'Invoicing > Billing Only > Invoice' },
    [Permissions.CommunicationsShipmentsTrucksView]: { display: 'Communications > Shipments > Trucks > View' },
    [Permissions.CommunicationsShipmentsTrucksSend]: { display: 'Communications > Shipments > Trucks > Send' },
    [Permissions.CommunicationsShipmentsContainersView]: { display: 'Communications > Shipments > Containers > View' },
    [Permissions.CommunicationsShipmentsContainersSend]: { display: 'Communications > Shipments > Containers > Send' },
    [Permissions.CommunicationsMailTriageProcessPending]: { display: 'Communications > Mail Triage > Process Pending' },
    [Permissions.CommunicationsMailTriageMarkDone]: { display: 'Communications > Mail Triage > Mark Done' },
    [Permissions.CommunicationsMailTriageView]: { display: 'Communications > Mail Triage > View' },
    [Permissions.CommunicationsActivityFeedView]: { display: 'Communications > Activity Feed > View' },
    [Permissions.CommunicationsActivityFeedResend]: { display: 'Communications > Activity Feed > Resend' },
    [Permissions.InventoryPhysicalCreate]: { display: 'Inventory > Physical > Create' },
    [Permissions.InventoryPhysicalRefreshPricing]: { display: 'Inventory > Physical > Refresh Pricing' },
    [Permissions.InventoryPhysicalControlGroupsView]: { display: 'Inventory > Physical > Control Groups > View' },
    [Permissions.InventoryPhysicalControlGroupsEdit]: { display: 'Inventory > Physical > Control Groups > Edit' },
    [Permissions.InventoryPhysicalShipmentsView]: { display: 'Inventory > Physical > Shipments > View' },
    [Permissions.InventoryPhysicalShipmentsEdit]: { display: 'Inventory > Physical > Shipments > Edit' },
    [Permissions.InventoryPhysicalOrdersView]: { display: 'Inventory > Physical > Orders > View' },
    [Permissions.InventoryPhysicalOrdersEdit]: { display: 'Inventory > Physical > Orders > Edit' },
    [Permissions.InventoryPhysicalAdjustmentsView]: { display: 'Inventory > Physical > Adjustments > View' },
    [Permissions.InventoryPhysicalAdjustmentsEdit]: { display: 'Inventory > Physical > Adjustments > Edit' },
    [Permissions.InventoryPhysicalReportsView]: { display: 'Inventory > Physical > Reports > View' },
    [Permissions.InventoryPhysicalReportsEdit]: { display: 'Inventory > Physical > Reports > Edit' },
    [Permissions.SupportActivityFeed]: { display: 'Support > Activity Feed' },
    [Permissions.SupportUsersCreate]: { display: 'Support > Users > Create' },
    [Permissions.SupportUsersView]: { display: 'Support > Users > View' },
    [Permissions.SupportUsersSave]: { display: 'Support > Users > Save' },
    [Permissions.SupportUsersDelete]: { display: 'Support > Users > Delete' },
    [Permissions.ProductionMetricsPickupsView]: { display: 'Production > Planning > Orders > View' },
    [Permissions.ProductionMetricsDeliveriesView]: { display: 'Production > Planning > Shipments > View' },
    [Permissions.ProductionMetricsCreateRun]: { display: 'Production > Planning > Create Run' },
    [Permissions.ProductionScheduleView]: { display: 'Production > Schedule (CD/OEM) > View' },
    [Permissions.ProductionScheduleSort]: { display: 'Production > Schedule > Sort' },
    [Permissions.ProductionScheduleJobs]: { display: 'Production > Schedule > Jobs' },
    [Permissions.ProductionScheduleRuns]: { display: 'Production > Schedule > Runs' },
    [Permissions.SupportDealersView]: { display: 'Support > Dealers > View' },
    [Permissions.SupportDealersEdit]: { display: 'Support > Dealers > Edit' },
    [Permissions.SupportDealersAddressOverride]: { display: 'Support > Dealers > Address Override' },
    [Permissions.SupportDealersReverseCredit]: { display: 'Support > Dealers > Reverse Credit' },
    [Permissions.InventoryPhysicalView]: { display: 'Inventory > Physical > View' },
    [Permissions.ApprovalsAddressesView]: { display: 'Approvals > Addresses > View' },
    [Permissions.ApprovalsCreditHoldView]: { display: 'Approvals > Credit Hold > View' },
    [Permissions.ApprovalsCreditHoldApprove]: { display: 'Approvals > Credit Hold > Approve' },
    [Permissions.RoutingRoutingView]: { display: 'Routing > Routing > View' },
    [Permissions.RoutingRoutingImport]: { display: 'Routing > Routing > Import' },
    [Permissions.ProductionScheduleRsView]: { display: 'Production > Schedule (RS) > View' },
    [Permissions.SupportDealersSales]: { display: 'Support > Dealers > Sales' },
};

/** Every permission there is, in the order of their numbers */
export const everyPermission = (): Permissions[] =>
    Object.keys(PermissionDetails).map(Number).sort((a, b) => a - b) as Permissions[];
